import { render, staticRenderFns } from "./SettingsListItem.vue?vue&type=template&id=b02d4258&"
import script from "./SettingsListItem.vue?vue&type=script&lang=js&"
export * from "./SettingsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports